import React, { useContext } from "react";
import styles from "./Cover.module.scss";
import stylesText from "../Text/Text.module.scss";
import PathContext from "../../context/path";
import clsx from "clsx";

const Cover = (props) => {
  const { img, position, name, desc, text, className, classNameText } = props;
  const path = useContext(PathContext);

  return (
    <>
      <div className={clsx(styles.wrap, className)}>
        <div className={styles.img}>
          <picture>
            <source
              media="(min-width: 1921px)"
              srcSet={`${path}/img/${img}@2x.webp`}
            />
            <source
              media="screen and (max-width: 767px)"
              srcSet={`${path}/img/${img}-mobile.webp, ${path}/img/${img}-mobile@2x.webp 2x`}
            />
            <img
              src={`${path}/img/${img}.webp`}
              srcSet={`${path}/img/${img}@2x.webp 2x`}
              alt=""
            />
          </picture>
        </div>
        <div className={styles.info}>
          <h1 className={styles.name}>{name}</h1>
          <div className={styles.position}>{position}</div>
          <div className={clsx(styles.text, stylesText.lid, classNameText)}>
            {text.map((item, index) => {
              return <p key={`cover-text-${index}`}>{item}</p>;
            })}
          </div>
        </div>
        <div className={styles.constructions}>{props.children}</div>
      </div>
    </>
  );
};

export default Cover;
